import { PRISM_SPACING_1000 } from '@mylighthouse/prism-foundation';

export function getDefaultTooltipOptions() {
  return {
    shared: false,
    hideDelay: 0.2,
    crosshairs: true,
    padding: 0,
    shadow: false,
    borderWidth: 0,
    useHTML: true,
    backgroundColor: 'transparent',
  };
}

function defaultChartOptions() {
  return {
    chart: {
      type: 'line',
      marginTop: PRISM_SPACING_1000,
    },
    rangeSelector: {
      selected: 1,
    },
    scrollbar: {
      enabled: false,
      liveRedraw: false,
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      enabled: true,
      borderWidth: 0,
      itemStyle: {
        width: 200,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: 'var(--prism-color-text-neutral-subdued)',
      },
      itemHoverStyle: {
        color: 'var(--prism-color-interactive-text-secondary-hover)',
      },
    },
    plotOptions: {
      column: {
        pointWidth: 10,
      },
      series: {
        connectNulls: true,
        dataLabels: {
          y: -25,
        },
        states: {
          inactive: {
            opacity: 1,
          },
        },
      },
    },
  };
}

/**
 * Gets the default chartOptions for Highcharts associated with rates charts
 * @return {Object} The chartOptions object
 */
export function getDefaultChartOptions(xAxis, yAxis, tooltip) {
  return {
    ...defaultChartOptions(),
    xAxis,
    yAxis,
    tooltip,
  };
}
